/*
 *
 * PayByLinkStoreSelector
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 08-Apr-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  storeCodeLabel: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.storeCodeLabel'
      defaultMessage='Codice punto vendita:'
    />
  ),
  selectStoreLabel: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.selectStore.label'
      defaultMessage='Punti vendita'
    />
  ),
  selectStorePlaceholder: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.selectStore.placeholder'
      defaultMessage='Seleziona punto vendita'
    />
  ),
  searchbarPlaceholder: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.selectStore.searchbar.placeholder'
      defaultMessage='Cerca per punto vendita, codice punto vendita ...'
    />
  ),
  selectAll: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.selectAll'
      defaultMessage='Seleziona tutti i risultati'
    />
  ),
  selectAllResults: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.selectAllResults'
      defaultMessage='Seleziona tutti i risultati'
    />
  ),
  selected: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.selected'
      defaultMessage='selezionati'
    />
  ),
  singleSelected: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.singleSelected'
      defaultMessage='selezionato'
    />
  ),
  reset: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.reset'
      defaultMessage='Azzera'
    />
  ),
  resetSelection: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.resetSelection'
      defaultMessage='Azzera selezione'
    />
  ),
  noResults: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.noResults'
      defaultMessage='Non sono presenti risultati per la ricerca effettuata.'
    />
  )
}

export default formattedMessage
